// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Privacy {
  display: grid;
  grid-template-columns: 1fr;
  justify-content: space-between;
  min-height: 100vh;
  text-align: center;
}
.Privacy-content {
  margin: 0 15px;
  text-align: justify;
}
.Privacy-content h1 {
  text-align: center;
  margin-bottom: 20px;
}
.Privacy-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0px 50px 0px;
}
.Privacy-btn {
  font-size: 14px;
  font-weight: 600;
  line-height: 25px;
  padding: 10px 20px;
}
.Privacy-terms p {
  font-size: 15px;
  line-height: 28px;
  padding: 10px 0px;
  color: #414042;
}
.Privacy-title-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 7rem;
}
.Privacy-title-section {
  width: max-content;
  color: #414042;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.8rem;
  line-height: 2.625rem;
  margin-bottom: 20px;
  position: relative;
}
.Privacy-title-section span:after {
  width: calc(100% + 6px);
  height: 1.6rem;
  background-color: #7dffd0;
  position: absolute;
  left: -3px;
  top: 12px;
  content: "";
  z-index: -1;
}

.PrivacyPolicyView--navigate {
  display: flex;
  gap: 2rem;
  padding: 24px;
  font-weight: 600;
}
.PrivacyPolicyView--navigate p {
  font-size: 18px;
  align-self: center;
}`, "",{"version":3,"sources":["webpack://./src/Views/beforeAuth/LoginView/PrivacyPolicy/privacy.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,0BAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;AACJ;AAAI;EACI,cAAA;EACA,mBAAA;AAER;AADQ;EACI,kBAAA;EACA,mBAAA;AAGZ;AAAI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;AAER;AAAI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAER;AAAI;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AAER;AAAI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAER;AAAI;EACI,kBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;AAER;AACI;EACI,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AACR;;AAGA;EACI,aAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;AAAJ;AACI;EACI,eAAA;EACA,kBAAA;AACR","sourcesContent":[".Privacy {\n    display: grid;\n    grid-template-columns: 1fr;\n    justify-content: space-between;\n    min-height: 100vh;\n    text-align: center;\n    &-content {\n        margin: 0 15px;\n        text-align: justify;\n        h1 {\n            text-align: center;\n            margin-bottom: 20px;\n        }\n    }\n    &-btn-container {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding: 40px 0px 50px 0px;\n    }\n    &-btn {\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 25px;\n        padding: 10px 20px;\n    }\n    &-terms p {\n        font-size: 15px;\n        line-height: 28px;\n        padding: 10px 0px;\n        color: #414042;\n    }\n    &-title-container {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin-top: 7rem;\n    }\n    &-title-section {\n        width: max-content;\n        color: #414042;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 2.8rem;\n        line-height: 2.625rem;\n        margin-bottom: 20px;\n        position: relative;\n    }\n\n    &-title-section span:after {\n        width: calc(100% + 6px);\n        height: 1.6rem;\n        background-color: #7dffd0;\n        position: absolute;\n        left: -3px;\n        top: 12px;\n        content: '';\n        z-index: -1;\n    }\n}\n\n.PrivacyPolicyView--navigate{\n    display: flex;\n    gap: 2rem;\n    padding: 24px;\n    font-weight: 600;\n    p{\n        font-size: 18px;\n        align-self: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
